module.exports = __webpack_public_path__ + "static/img/90.9bd842ac.png";